import React from 'react';
import { TextLink } from 'atoms';
import { LEGAL_LINKS } from 'constants/routes';

const FooterLinksRow: React.FC = () => {
  return (
    <>
      {LEGAL_LINKS.map((link) => (
        <TextLink key={link.to} className="site-footer-link" to={link.to}>
          {link.label}
        </TextLink>
      ))}
    </>
  );
};

export default FooterLinksRow;
